var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgressPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1438_16961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 8C15.4286 8 9 14.4286 9 22.2857C9 26 10.4286 29.7143 13.1429 32.4286L22.2857 41.8571C22.8571 42.4286 23.7143 42.4286 24.2857 41.8571L33.2857 32.4286C36.1429 29.7143 37.5714 26.1429 37.5714 22.2857C37.5714 14.4286 31.1429 8 23.2857 8Z",
    fill: "#7879F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2861 7.25C31.5573 7.25023 38.3213 14.0149 38.3213 22.2861C38.3212 26.3369 36.8171 30.1089 33.8027 32.9727L24.8281 42.375L24.8223 42.3809L24.8164 42.3877C23.9522 43.2519 22.6202 43.2517 21.7559 42.3877L21.7471 42.3789L12.6123 32.958V32.959C9.74964 30.0963 8.25011 26.1877 8.25 22.2861C8.25 14.0148 15.0148 7.25 23.2861 7.25Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1438_16961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4074 24.6895L33.7524 21.059C33.9047 20.6449 33.5578 20.2418 33.1202 20.3313L32.1138 20.5373C31.2721 17.5822 28.9347 15.1155 25.7513 14.2626C21.8155 13.208 17.7992 14.9234 15.7432 18.1979C15.5692 18.4615 15.718 18.8322 16.0267 18.9149L17.1264 19.2096C17.3193 19.2613 17.5239 19.192 17.6283 19.0339C19.2575 16.6582 22.2915 15.4447 25.224 16.2304C27.6357 16.8766 29.436 18.7238 30.1204 20.9543L29.114 21.1603C28.6957 21.255 28.5369 21.7707 28.8273 22.076L31.513 24.8634C31.7841 25.1636 32.2654 25.0651 32.4074 24.6895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0681 31.7422C25.0038 32.7968 29.0201 31.0814 31.0762 27.8068C31.2502 27.5433 31.1014 27.1726 30.7927 27.0899L29.693 26.7952C29.5001 26.7435 29.2954 26.8127 29.191 26.9709C27.5619 29.3466 24.5279 30.5601 21.5954 29.7743C19.1837 29.1281 17.3834 27.281 16.699 25.0504L17.7054 24.8445C18.1237 24.7498 18.2825 24.234 17.9921 23.9288L15.3064 21.1413C15.0353 20.8412 14.5295 20.9538 14.3876 21.3293L13.0426 24.9598C12.8902 25.374 13.2371 25.7771 13.6747 25.6875L14.6811 25.4816C15.5473 28.4226 17.8847 30.8892 21.0681 31.7422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1438_16961",
    x: 0.7,
    y: 0.7,
    width: 45.1715,
    height: 50.8856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1438_16961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1438_16961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1438_16961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(35.6475 15.9287) rotate(105)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressPinIcon);
export default __webpack_public_path__ + "static/media/InProgressPinIcon.7eb23da8820745c8bffd7861abfa0c7a.svg";
export { ForwardRef as ReactComponent };